// interface IContentParams {
//   contentKey: string;
//   contentRoute: string[];
//   where?: Record<string, any>;
//   isPage?: boolean;
//   only?: string[];
//   findAll?: boolean;
//   currentOnly?: boolean;
// }

export function useContentLogic(params) {
  const globalStore = useGlobalStore();
  const { currentLocale, defaultLocale } = storeToRefs(globalStore);
  const {
    // setPageMeta,
    getLocalesContentData,
  } = useProjectMethods();

  const getRequestArray = () => {
    let currentLocaleQuery = queryContent(
      currentLocale.value?.code,
      ...params.contentRoute
    );
    let defaultLocaleQuery = params.currentOnly
      ? undefined
      : queryContent(defaultLocale.value?.code, ...params.contentRoute);

    if (params.only) {
      currentLocaleQuery = currentLocaleQuery.only(params.only);
      if (!params.currentOnly)
        defaultLocaleQuery = defaultLocaleQuery.only(params.only);
    }

    if (params.where) {
      currentLocaleQuery = currentLocaleQuery.where(params.where);
      if (!params.currentOnly)
        defaultLocaleQuery = defaultLocaleQuery.where(params.where);
    }

    if (params.findAll) {
      return params.currentOnly
        ? [currentLocaleQuery.find(), undefined]
        : [
            currentLocaleQuery.find(),
            currentLocale.value?.isDefault
              ? Promise.reject("Current locale is default locale!")
              : defaultLocaleQuery.find(),
          ];
    }

    return params.currentOnly
      ? [currentLocaleQuery.findOne(), undefined]
      : [
          currentLocaleQuery.findOne(),
          currentLocale.value?.isDefault
            ? Promise.reject("Current locale is default locale!")
            : defaultLocaleQuery.findOne(),
        ];
  };

  const getContentData = async () => {
    let contentData = {
      currentLocaleData: undefined,
      defaultLocaleData: undefined,
    };

    const { data: nuxtDataContent } = useNuxtData(params.contentKey);

    if (nuxtDataContent.value) contentData = nuxtDataContent.value;
    else {
      const [currentLocaleContentResponse, defaultLocaleContentResponse] =
        await Promise.allSettled(getRequestArray());
      contentData = getLocalesContentData(
        currentLocaleContentResponse,
        defaultLocaleContentResponse
      );
      nuxtDataContent.value = contentData;
    }

    // if (params.isPage) setPageMeta(contentData.currentLocaleData?.pageMeta);
    return contentData;
  };

  return { getContentData };
}
